import { Adornment, Combobox as ConstellationCombobox, Form as ConstellationForm, Input } from '@zillow/constellation';
import styled from 'styled-components';

import type { AutocompleteAreaInputType } from '.';

export const SearchInput = styled(Input)<{ type: AutocompleteAreaInputType }>`
    ${(props) => (props.type === 'secondary' ? 'background-color: white;' : '')}
`;

export const SearchAdornment = styled(Adornment)<{ type: AutocompleteAreaInputType }>`
    ${(props) => (props.type === 'secondary' ? 'background-color: white;' : '')}
    ${(props) => (props.type === 'primary' ? 'color: #006AFF;' : '')}
    cursor: pointer;
`;

export const Form = styled(ConstellationForm)`
    max-width: 485px;
    flex-basis: 485px;
`;

export const Combobox = styled(ConstellationCombobox)`
    width: 100%;
`;
